var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeType3Content',{ref:"contentRef",attrs:{"homeInfo":_vm.homeInfo,"expertConfig":_vm.expertConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }